/* LUADA 2 – LP „7 Tage risikofrei testen" (Google Ads)
 * Lead-Submit + Kontakt-Routing + Scarcity + Pre-Qualifier
 * Basiert auf lp-pflegekasse.js – angepasst für 7-Tage-Test-Flow
 */
(function () {
  'use strict';

  var cfg = window.LP_G7_CONFIG || {};

  // ----------------------------------------------------------------
  // 1. Telefon (Mo-Fr 08-12) vs. WhatsApp (außerhalb)
  // ----------------------------------------------------------------
  function isPhoneOpen() {
    try {
      var fmt = new Intl.DateTimeFormat('de-DE', {
        timeZone: 'Europe/Berlin',
        weekday: 'short',
        hour: '2-digit',
        hour12: false
      });
      var parts = fmt.formatToParts(new Date());
      var weekday = '', hour = 0;
      parts.forEach(function (p) {
        if (p.type === 'weekday') weekday = p.value;
        if (p.type === 'hour') hour = parseInt(p.value, 10);
      });
      var isWeekday = /^(Mo|Di|Mi|Do|Fr)/i.test(weekday);
      return isWeekday && hour >= 8 && hour < 12;
    } catch (e) {
      var d = new Date();
      return d.getDay() >= 1 && d.getDay() <= 5 && d.getHours() >= 8 && d.getHours() < 12;
    }
  }

  function applyContactState() {
    var open = isPhoneOpen();
    var sec = document.getElementById('lp-secondary-cta');
    var secText = document.getElementById('lp-sec-text');
    var secPhone = document.getElementById('lp-sec-phone');
    var secWA = document.getElementById('lp-sec-whatsapp');
    if (sec) {
      sec.hidden = false;
      if (open) {
        if (secPhone) secPhone.hidden = false;
        if (secWA) secWA.hidden = true;
        if (secText) secText.textContent = 'Oder lieber direkt anrufen?';
      } else {
        if (secPhone) secPhone.hidden = true;
        if (secWA) secWA.hidden = false;
        if (secText) secText.textContent = 'Außerhalb der Telefonzeit? Schreiben Sie uns:';
      }
    }
  }

  // Scarcity entfernt – nicht glaubwürdig für einen Gratis-Test (Verbesserung #4)

  // Pre-Qualifier entfernt – Formular ist direkt sichtbar

  // ----------------------------------------------------------------
  // 4. UTM + fbclid aus URL (mit sessionStorage-Cache)
  // ----------------------------------------------------------------
  function getUtmParams() {
    var params = {};
    try {
      var sp = new URLSearchParams(location.search);
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term', 'fbclid', 'gclid'].forEach(function (k) {
        var v = sp.get(k); if (v) params[k] = v;
      });
      if (params.fbclid) sessionStorage.setItem('lp_fbclid', params.fbclid);
      else { var c = sessionStorage.getItem('lp_fbclid'); if (c) params.fbclid = c; }
      ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'].forEach(function (k) {
        if (params[k]) sessionStorage.setItem('lp_' + k, params[k]);
        else { var c2 = sessionStorage.getItem('lp_' + k); if (c2) params[k] = c2; }
      });
    } catch (e) {}
    return params;
  }

  // UUID v4 für FB-Pixel Event-ID (CAPI-Deduplication)
  function generateEventId() {
    try {
      return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, function (c) {
        return (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16);
      });
    } catch (e) { return Math.random().toString(36).slice(2) + Date.now().toString(36); }
  }

  // ----------------------------------------------------------------
  // 5. Form Submit
  // ----------------------------------------------------------------
  function setError(msg) {
    var el = document.getElementById('lp-form-error');
    if (!el) return;
    if (msg) { el.textContent = msg; el.classList.add('is-visible'); }
    else { el.textContent = ''; el.classList.remove('is-visible'); }
  }

  function getCookie(name) {
    return document.cookie.split('; ').reduce(function (r, v) {
      var p = v.split('=');
      return p[0] === name ? decodeURIComponent(p[1]) : r;
    }, '');
  }

  function handleSubmit(e) {
    e.preventDefault();
    setError('');
    var form = e.target;
    var fd = new FormData(form);

    // Honeypot
    if ((fd.get('_hp') || '').toString().trim() !== '') { showSuccess(); return; }

    // Pflichtfelder
    var required = ['vorname', 'phone', 'email', 'consent'];
    for (var i = 0; i < required.length; i++) {
      var v = fd.get(required[i]);
      if (!v || (typeof v === 'string' && !v.trim())) {
        setError('Bitte füllen Sie alle Pflichtfelder aus und akzeptieren Sie die Datenschutzerklärung.');
        var first = form.querySelector('[name="' + required[i] + '"]');
        if (first && first.focus) first.focus();
        return;
      }
    }

    var email = (fd.get('email') || '').toString().trim();
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      setError('Bitte geben Sie eine gültige E-Mail-Adresse ein.');
      var eInp = form.querySelector('[name="email"]'); if (eInp) eInp.focus();
      return;
    }

    var phone = (fd.get('phone') || '').toString().trim();
    if (!/^[\d\s\+\(\)\-\/]{6,20}$/.test(phone)) {
      setError('Bitte geben Sie eine gültige Telefonnummer ein (z. B. 0170 1234567).');
      var pInp = form.querySelector('[name="phone"]'); if (pInp) pInp.focus();
      return;
    }

    var btn = document.getElementById('lp-submit');
    if (btn) { btn.disabled = true; btn.textContent = 'Wird gesendet …'; }

    var utms = getUtmParams();
    var eventId = generateEventId();

    var payload = {
      vorname: (fd.get('vorname') || '').toString().trim(),
      nachname: (fd.get('nachname') || '').toString().trim(),
      phone: phone,
      email: email,
      fuer_wen: (fd.get('fuer_wen') || '').toString(),
      consent: !!fd.get('consent'),
      source: fd.get('source') || 'lp-7tage-google',
      page_url: location.href,
      referrer: document.referrer || '',
      fbc: getCookie('_fbc') || '',
      fbp: getCookie('_fbp') || '',
      fbclid: utms.fbclid || '',
      gclid: utms.gclid || '',
      utm_source: utms.utm_source || '',
      utm_medium: utms.utm_medium || '',
      utm_campaign: utms.utm_campaign || '',
      utm_content: utms.utm_content || '',
      utm_term: utms.utm_term || '',
      event_id: eventId,
      ts: new Date().toISOString()
    };

    fetch(cfg.webhookUrl || 'https://webhook.luada.de/lead', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(payload),
      mode: 'cors',
      credentials: 'omit'
    }).then(function (res) {
      if (!res.ok) throw new Error('HTTP ' + res.status);
      // Pixel-Events
      try {
        if (window.fbq) {
          window.fbq('track', 'Lead', { content_name: '7tage-test-google', content_category: 'lead' }, { eventID: eventId });
        }
      } catch (e) {}
      try {
        if (window.gtag) {
          window.gtag('event', 'generate_lead', { event_category: 'lead', event_label: '7tage-test-google' });
        }
      } catch (e) {}
      try {
        window.dataLayer = window.dataLayer || [];
        window.dataLayer.push({
          event: 'lp_lead_submit',
          fuer_wen: payload.fuer_wen,
          utm_source: payload.utm_source,
          utm_campaign: payload.utm_campaign,
          event_id: eventId
        });
      } catch (e) {}
      try { sessionStorage.setItem('lp_lead_event_id', eventId); } catch (e) {}
      showSuccess();
    }).catch(function () {
      setError('Es gab ein Problem beim Senden. Bitte versuchen Sie es erneut oder rufen Sie uns direkt an.');
      if (btn) { btn.disabled = false; btn.textContent = 'Jetzt kostenlos anfragen'; }
    });
  }

  function showSuccess() {
    var form = document.getElementById('lp-form');
    var succ = document.getElementById('lp-success');
    if (form) form.style.display = 'none';
    if (succ) succ.classList.add('is-visible');
    if (succ && succ.scrollIntoView) succ.scrollIntoView({ behavior: 'smooth', block: 'center' });
    var thankYouUrl = cfg.thankYouUrl || '/pages/danke-7tage';
    setTimeout(function () { try { window.location.href = thankYouUrl; } catch (e) {} }, 1800);
  }

  // ----------------------------------------------------------------
  // 6. Sticky Mobile CTA – nach dem Hero einblenden
  // ----------------------------------------------------------------
  function initStickyCta() {
    var sticky = document.getElementById('lp-sticky');
    var hero = document.getElementById('lp-hero');
    if (!sticky || !hero) return;
    function check() {
      var threshold = hero.offsetTop + hero.offsetHeight;
      if (window.scrollY > threshold) {
        sticky.hidden = false;
        requestAnimationFrame(function () { sticky.classList.add('is-visible'); });
        window.removeEventListener('scroll', check, { passive: true });
      }
    }
    window.addEventListener('scroll', check, { passive: true });
  }

  // ----------------------------------------------------------------
  // 7. Init
  // ----------------------------------------------------------------
  // ----------------------------------------------------------------
  // Telefon im Hero: nur einblenden wenn Mo-Fr 08-12
  // ----------------------------------------------------------------
  function initHeroPhone() {
    var wrap = document.getElementById('lp-hero-phone-wrap');
    if (!wrap) return;
    if (isPhoneOpen()) { wrap.hidden = false; }
  }

  function init() {
    applyContactState();
    setInterval(applyContactState, 5 * 60 * 1000);
    initStickyCta();
    initHeroPhone();
    var pageUrl = document.getElementById('lp-pageurl');
    if (pageUrl) pageUrl.value = location.href;
    var form = document.getElementById('lp-form');
    if (form) form.addEventListener('submit', handleSubmit);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
